import React from "react";
import { LucideBarChart3, LucideCheckCircle } from "lucide-react";
import { LuClipboardList, LuPenTool, LuRefreshCw, LuShare2 } from "react-icons/lu";
import { FiBarChart, FiEdit3, FiFileText, FiMail, FiTarget, FiVideo } from "react-icons/fi";

export const contentMarketingHeroData = {
  backgroundImage: "/images/serviceBanners/ContentMarketing.webp",
  whiteImage: "/images/serviceBanners/ContentMarketingWhite.webp",
  subTitle: "Content Marketing Services",
  title: (
    <>
      High Performance <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Strategic Content </span> System
    </>
  ),
  description:
    "We build structured and intent driven content marketing systems that attract the right audience, strengthen brand authority, and drive measurable business growth through valuable, consistent, and strategy focused content creation.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("AI Start clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("AI Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Content Strategy Planning",
      desc: "Optimized for speed and sub-second inference.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Audience Research System",
      desc: "Cloud-agnostic deployments (AWS/GCP/Azure).",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "SEO Driven Content Creation",
      desc: "Enterprise-grade model governance and privacy.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Authority Building Content",
      desc: "Clean, maintainable, and monitorable pipelines.",
      iconColor: "#34d399",
    },
  ],
};

export const contentMarketingAndProcessData = {
  buildSubtitle: "CONTENT MARKETING SOLUTIONS",
  buildTitle: "Content Marketing Solutions for Every Requirement",
  buildCards: [
    {
      title: "Content Strategy & Editorial Planning",
      desc: "Develop structured content plans based on audience research, keyword intent, and business objectives.",
      icon: FiTarget,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Blog & Article Writing",
      desc: "Create long form, SEO optimized articles that build authority and improve organic visibility.",
      icon: FiEdit3,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Whitepapers, Case Studies & E-books",
      desc: "Design high value content assets for lead generation and brand credibility.",
      icon: FiFileText,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Video Content & Motion Graphics",
      desc: "Produce engaging visual content including explainer videos, reels, and brand storytelling formats.",
      icon: FiVideo,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
    {
      title: "Email & Newsletter Content",
      desc: "Create structured email campaigns and newsletters for audience engagement and retention.",
      icon: FiMail,
      colorClass: "text-[#ec4899]",
      bgClass: "bg-[#ec4899]/10",
      borderClass: "border-[#ec4899]/20 hover:border-[#ec4899]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(236,72,153,0.25)]",
    },
    {
      title: "Infographics & Visual Content",
      desc: "Transform complex data into simple, shareable, and visually engaging content formats.",
      icon: FiBarChart,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
  ],
  processSubtitle: "CONTENT MARKETING ENGINEERING FRAMEWORK",
  processTitle: "How We Build Scalable Content Systems",
  processSteps: [
    {
      step: "01",
      title: "Content Strategy Planning",
      description: "Plan content direction based on audience research, keyword intent, and business goals.",
      icon: LuClipboardList,
    },
    {
      step: "02",
      title: "Agile Content Execution",
      description: "Publish and refine content in structured cycles to improve reach and engagement.",
      icon: LuRefreshCw,
    },
    {
      step: "03",
      title: "Content Development System",
      description: "Create high quality blogs, articles, and assets designed for audience value and SEO impact.",
      icon: LuPenTool,
    },
    {
      step: "04",
      title: "Content Distribution Management",
      description: "Manage multi channel distribution across blogs, social media, email, and platforms.",
      icon: LuShare2,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "Improve content reach, engagement, and conversion using analytics and insights.",
      icon: LucideBarChart3,
    },
    {
      step: "06",
      title: "Quality Assurance System",
      description: "Ensure content consistency, accuracy, and brand alignment across all formats.",
      icon: LucideCheckCircle,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN CONTENT MARKETING SYSTEMS?",
  benefitsTitle: "Why Businesses Choose Content Marketing",
  benefits: [
    "Strong brand authority building",
    "Long term organic growth",
    "Consistent audience engagement",
    "Better lead generation potential",
    "SEO driven visibility improvement",
    "Cost effective marketing channel",
    "Sustainable business growth engine",
  ],
  logoImage: "/images/serviceBanners/ContentMarketingBanner.webp",
  whiteLogoImage: "/images/serviceBanners/ContentMarketingW.webp",
};

export const aiTechnologiesData = {
  techTitle: "OUR EXTENSIVE TOOL STACK",
  technologies: [
    { name: "TensorFlow", icon: "RestAPI" },
    { name: "PyTorch", icon: "Code" },
    { name: "OpenAI", icon: "Provider" },
    { name: "Python", icon: "Dart" },
    { name: "Docker", icon: "Vite" },
    { name: "Kubernetes", icon: "Firebase" },
  ],
  trustTitle: "TRUSTED BY INNOVATORS WORLDWIDE",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle" },
  ],
};

export const contentMarketingAboutData = [
  {
    title: "Content Marketing Services for Sustainable Brand Growth",
    content: (
      <>
        Creating content without a clear strategy often leads to inconsistent results and limited business impact. Professional{" "}
        <b className="text-text-primary font-semibold">Content Marketing Services</b> help businesses attract the right audience, build credibility, and strengthen customer
        relationships through valuable information. Many organizations publish content regularly but struggle to generate meaningful engagement or conversions. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, content strategies are developed around audience intent, business objectives, and market
        opportunities to help brands create lasting digital growth through purposeful communication.
      </>
    ),
  },
  {
    title: "Content Marketing Agency India for Audience Engagement",
    content: (
      <>
        Successful content marketing starts with understanding what customers want to learn, explore, and trust. A trusted{" "}
        <b className="text-text-primary font-semibold">Content Marketing Agency India</b> helps businesses create relevant content that answers questions, solves problems, and
        supports decision making throughout the customer journey. Companies investing in strategic content initiatives often experience stronger audience engagement because content
        is aligned with real user interests and business goals. Tycho Technologies focuses on building scalable content frameworks that help organizations establish authority while
        improving customer connections.
      </>
    ),
  },
  {
    title: "SEO Content Writing Services That Improve Visibility",
    content: (
      <>
        Search visibility depends on creating content that serves both users and search engines effectively. Reliable{" "}
        <b className="text-text-primary font-semibold">SEO Content Writing Services</b> help businesses improve discoverability by producing valuable content aligned with search
        intent and industry trends. Organizations that consistently invest in high-quality content often strengthen their online presence while attracting qualified visitors
        interested in their products or services. Well-structured content also supports trust building, making it easier for businesses to convert visitors into long-term
        customers.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Content Strategy Services",
    content: (
      <>
        The demand for professional <b className="text-text-primary font-semibold">Content Strategy Services</b> continues to grow as companies seek more predictable and measurable
        marketing outcomes. Businesses that prioritize strategic planning are better positioned to create content that supports both customer needs and commercial objectives.
        Companies partnering with Tycho Technologies gain access to customized content frameworks designed around measurable growth goals and audience behavior. Combined with{" "}
        <b className="text-text-primary font-semibold">Blog Writing Services</b>, a structured content strategy helps organizations improve authority, strengthen visibility, and
        create sustainable long-term business growth.
      </>
    ),
  },
];

export const contentMarketingFaqs = [
  {
    q: "How does content marketing help businesses generate qualified leads?",
    a: "Content marketing attracts potential customers by providing valuable information that addresses their questions and challenges. Well-planned content builds trust, nurtures prospects, and guides them through the buying journey, increasing lead generation opportunities.",
  },
  {
    q: "What types of content should businesses include in a content marketing strategy?",
    a: "A comprehensive content marketing strategy can include blogs, articles, case studies, whitepapers, e-books, videos, newsletters, infographics, and educational resources tailored to audience needs and business goals.",
  },
  {
    q: "How long does it take to see results from content marketing services?",
    a: "Content marketing is a long-term growth strategy. While some improvements in engagement and traffic can be seen within a few months, significant gains in authority, organic visibility, and lead generation typically develop through consistent content efforts over time.",
  },
  {
    q: "How does Tycho Technologies create content that aligns with business goals?",
    a: "Tycho Technologies develops content strategies based on audience research, search intent, industry trends, and business objectives. This approach ensures that every content asset supports brand authority, audience engagement, and measurable growth outcomes.",
  },
  {
    q: "Why should businesses choose Tycho Technologies for content marketing services?",
    a: "Tycho Technologies combines content strategy, SEO expertise, audience insights, and performance optimization to create scalable content systems that improve visibility, strengthen brand authority, and support long-term business growth.",
  },
];
